const API_IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL;
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL || "localhost:7714";
const TENANT_APP_URL = process.env.REACT_APP_TENANT_APP_URL;
const MASTER_APP_URL = process.env.REACT_APP_MASTER_APP_URL;
const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_API_KEY;
const MODE = process.env.REACT_APP_MODE;
// const PAYCENTRAL_MEDIA_URL = "http://localhost:3010/api/public";
// const BACKEND_URL = "http://localhost:6996";
const BACKEND_URL = "https://paycentral-apimaster.netcluesdemo.com";
const PAYCENTRAL_MEDIA_URL = "https://paycentral-media.netcluesdemo.com/api/public";

const CRYPTO_TOKEN_SECRET_KEY = process.env.REACT_APP_CRYPTO_TOKEN_SECRET_KEY;
const REACT_APP_ENCRYPTION = process.env.REACT_APP_ENCRYPTION;
const REACT_APP_DECRYPTION = process.env.REACT_APP_DECRYPTION;
const REACT_APP_CIPHERALGORITHM = process.env.REACT_APP_CIPHERALGORITHM;
const REACT_APP_CIPHERSKEY = process.env.REACT_APP_CIPHERSKEY;
const REACT_APP_CIPHERVIKEY = process.env.REACT_APP_CIPHERVIKEY;
const REACT_APP_PROFILE_FOLDER_NAME = process.env.REACT_APP_PROFILE_FOLDER_NAME || "profilePics";

const DEFAULT_PAGE_SIZE = Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 10;
const DEFAULT_LOGOUT_TIME_IN_MINUTE = Number(process.env.REACT_APP_DEFAULT_LOGOUT_TIME_IN_MINUTE) || 30;

const NETCLUES_URL = process.env.REACT_APP_NETCLUES_URL;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;

export const ITEMS_PER_PAGE_OPTIONS = [10, 50, 100, 500, 1000];

export {
  API_IMAGE_URL,
  MODE,
  SOCKET_URL,
  MEDIA_URL,
  DOMAIN_URL,
  TENANT_APP_URL,
  MASTER_APP_URL,
  TINYMCE_API_KEY,
  CRYPTO_TOKEN_SECRET_KEY,
  REACT_APP_ENCRYPTION,
  REACT_APP_DECRYPTION,
  REACT_APP_CIPHERALGORITHM,
  REACT_APP_CIPHERSKEY,
  REACT_APP_CIPHERVIKEY,
  REACT_APP_PROFILE_FOLDER_NAME,
  DEFAULT_PAGE_SIZE,
  DEFAULT_LOGOUT_TIME_IN_MINUTE,
  NETCLUES_URL,
  SUPPORT_EMAIL,
  PAYCENTRAL_MEDIA_URL,
  BACKEND_URL
};
